var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{attrs:{"color":_vm.avatarColor,"size":_vm.size,"title":_vm.user.name}},[_c('span',{style:(`color:#fff; font-size:${Math.floor(_vm.size / 2)}px`)},[_vm._v(_vm._s(_vm.nameLetters))])])
}
var staticRenderFns = []

export { render, staticRenderFns }